import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import ThemeContextProvider from './theme/ThemeContextProvider';
 import KeycloakProvider from './auth/KeycloakProvider';
 import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ConfigProvider } from './context/ConfigContext'; 
import { Provider } from 'react-redux';
import store from './store/store';
// import { StyledEngineProvider } from '@mui/material/styles';
// import '@mui/material/styles';
// import '@mui/material/Grid'; 
import * as serviceWorkerRegistration from './serviceWorkerRegistration'; // ✅ add this
import { SessionAuthProvider } from './auth/SessionAuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   
    <Provider store={store}>
      <ThemeContextProvider>
          <ConfigProvider> 
            <SessionAuthProvider>
              <BrowserRouter>
                <LocalizationProvider dateAdapter={AdapterDayjs}>           
                    <App />        
                </LocalizationProvider>
              </BrowserRouter>
            </SessionAuthProvider>
          </ConfigProvider>
        </ThemeContextProvider>
    </Provider> 
 
);

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    if (window.confirm('New version available. Reload now?')) {
      registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
      window.location.reload();
    }
  },
});
